import { IDataset } from "@/analytics/pages/dataset/dataset-edit";
import { IDetailPageData } from "../../../shared/utils/api";
import { IEventBackendType } from "../transformers/event-transformer";

export interface IDatasetBackendType {
  id?: string,
  label_list_id?: string,
  label_list_name?: string,
  event_id: string,
  event_name?: string,
  tmsconfig_id?: string,
  selected_template_layout_id?: string,
  selected_template_layout_name?: string,
  selected_pdf_template_layout_id?: string,
  selected_pdf_template_layout_name?: string,
  tmsconfig_name?: string,
  dataset_name: string,
  timeframe_from: string,
  timeframe_to: string,
  model_type: string,
  event_type_fields?: IEventBackendType,
  fields?: IEventBackendType,
  labels: {
    id: string,
    label: string,
    datamodel_field_id: string,
    datamodel_id: string,
    datamodel_type: string,
    positive?: string,
    negative?: string,
    amount_direction?:string,
    amount_direction_id?:string,
    total_rows?: number,
  }[];
}

export function transformToBackendDataset(data: IDataset): any | undefined { // eslint-disable-line
  if(!data){
    return undefined;
  }

  return {
    id: data.id,
    dataset_name: data.dataset_name,
    event_id: data.event_id,
    tmsconfig_id: data.tmsconfig_id,
    model_type: data.model_type,
    selected_template_layout_id: data.selected_template_layout_id,
    selected_pdf_template_layout_id: data.selected_pdf_template_layout_id,
    timeframe_from: data.timeframe_from,
    timeframe_to: data.timeframe_to,
    labels: data.labels.map(row => ({
      id: row.id,
      label: row.label,
      amount_direction_id: row.amount_direction_id,
      datamodel_field_id: row.datamodel_field_id,
      datamodel_id: row.datamodel_id,
      datamodel_type: row.datamodel_type,
      datamodel_reference_field_id: row.datamodel_reference_field_id,
      datamodel_referencing_component_group_id: row.datamodel_referencing_component_group_id,
      negative: row.negative,
      positive: row.positive
    }))
  };
}

export function transformFromBackendDataset(backendType: IDatasetBackendType): IDetailPageData {
  return {
    id: backendType.id,
    event_id: backendType.event_id,
    event_name: backendType.event_name,
    tmsconfig_id: backendType.tmsconfig_id,
    tmsconfig_name: backendType.tmsconfig_name,
    selected_template_layout_id: backendType.selected_template_layout_id,
    selected_template_layout_name: backendType.selected_template_layout_name,
    selected_pdf_template_layout_id: backendType.selected_pdf_template_layout_id,
    selected_pdf_template_layout_name: backendType.selected_pdf_template_layout_name,
    dataset_name: backendType.dataset_name,
    model_type: backendType.model_type,
    timeframe_from: backendType.timeframe_from? backendType.timeframe_from : "",
    timeframe_to: backendType.timeframe_to? backendType.timeframe_to : "",
    event_type_fields: backendType.event_type_fields,
    labels: backendType.labels,
    rowData: []
  };
}